import { ActionHandler } from "../../../common/actions/core/action-handler";
import { Action } from "../../../common/actions/core/action";
import { UserResponse } from "../../../common/services/user/user.model";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import UserService from "../../../common/services/user/user.service";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import {OpenStudentSuccessfulAction} from "./successful.action";
import { Date } from '../../../common/services/package/package.model';

/*@ngInject*/
export default class OpenStudentSuccessController implements ActionHandler{
  protected user: UserResponse;
  protected dialogElement;
  protected packageId:String;
  protected endDate: Date;

  constructor(
    protected $element,
    private $state,
    private $window,
    protected actionDispatcher: ActionDispatcherService,
    protected globalSpinner: GlobalSpinnerService,
    protected userService: UserService
  ) {

  }

  public $postLink() {
    this.dialogElement = this.$element.find('#student-plan-application-success-modal').remodal();
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }
  public handle(action: Action) {
    if (action instanceof OpenStudentSuccessfulAction) {
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenStudentSuccessfulAction) {
    this.packageId = action.packageId;
    this.endDate = action.endDate;
    this.globalSpinner.start();
    this.userService.getUserInfo()
      .then(data => {
        this.user = data;
        this.openDialog();
      })
      .finally(() => {
        this.globalSpinner.stop();
      });
  }

  public onCancel() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
   this.dialogElement.close();
   this.$state.go('buy', {
      packetId: this.packageId
    });
    this.$window.scrollTo(0, 0); 
  }

}



// WEBPACK FOOTER //
// ./src/app/components/student/successful/successful.controller.ts